import React, { Component } from 'react';

class appointmentForm extends Component{
	render(){
		return(
			<>
				<div className="appointment-form form-wraper">
					<h3 className="title">Agendar Turno</h3>
					<form action="#">
					
						<div className="form-group">
							<input type="text" className="form-control" placeholder="Nombre y apellido"/>
						</div>
						<div className="form-group">
							<input type="number" className="form-control" placeholder="Número telefonico"/>
						</div>
						<div className="form-group">
							<input type="email" className="form-control" placeholder="Correo electronico"/>
						</div>
						<div className="form-group">
							<input type="date" className="form-control"/>
						</div>
						<button type="submit" className="btn btn-secondary btn-lg">Agendar</button>
					</form>
				</div>
			
			</>
		);
	}
}

export default appointmentForm;